export default __webpack_public_path__ + "static/lozenge-do-1-dark-0e4ca03a7d53cbbf54811a0ed71d28cec9d116454d0dc440f7c37289bdc8e1ab.png";